// extracted by mini-css-extract-plugin
export default {"title":"auto-entry-campaigns-screen_title__quDip"};